import { usingGet } from '@ocean/api'

export const getCertificateDetails = (certificateId: Guid, resultId?: Guid) => {
  const baseUrl = `certificates/details/${certificateId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}
